module.exports = __webpack_public_path__ + "img/ty0.b07d02cb.png";